<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-22 14:50:00
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/list/components/BottomBtn/index.vue
-->
<template>
  <div>
    <div class="clearfix bottom_brn">
      <div
        v-if="i.afterInfo"
        class="left font12 font_weight500 colof00 line_height_14 refund_det text_left"
      >
        {{ i.afterInfo }}
      </div>
      <div class="right right_btn">
        <div
          v-for="(btn, index) in computedBtnList"
          :key="index"
          :class="{
            pay_btn: btn.isLightHeight,
            colof: btn.isLightHeight,
            btn_mr: index !== 0
          }"
          class="cancel_btn colo087 font12 font_weight400 line_height_30"
          @click="clickBtn(btn.name)"
        >
          {{ btn.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    btnList: {
      type: Array,
      default() {
        return [];
      }
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    i: {
      type: Object,
      default() {
        return {};
      }
    },
    packageIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  computed: {
    computedBtnList() {
      const item = this.item;
      const i = this.i || {};
      if (!item) return [];

      const status =
        item.status === 10
          ? item.status
          : i.status !== undefined
          ? i.status
          : item.status;
      const orderType =
        i.orderType !== undefined ? i.orderType : item.orderType;

      // 判断再次购买展示逻辑
      const isOrderDetailPage =
        this.$route.name === "OrderDetail" ||
        this.$route.path === "/order/detail";
      const allowBuyAgain =
        !isOrderDetailPage &&
        [0, 1, 2, 9, 10].includes(item.kind) &&
        item.buyAgainButtonShow !== 1;

      if (this.isCloseStatus(status)) {
        const btns = [
          {
            name: "删除订单",
            isLightHeight: false
          }
        ];
        if (allowBuyAgain) {
          btns.push({
            name: "再次购买",
            isLightHeight: true
          });
        }
        return btns;
      }

      switch (status) {
        case 5:
        case -5:
        case -9:
          return [];
        // 待付款
        case 10: {
          const payBtns = [
            {
              name: "取消订单",
              isLightHeight: false
            }
          ];
          if (item.kind === 10) {
            payBtns.push({
              name: "分享订单",
              isLightHeight: true
            });
          }
          const hidePayButton = item.kind === 10 && item.isCrossBorderOrder;
          if (!hidePayButton) {
            payBtns.push({
              name: "去付款",
              isLightHeight: true
            });
          }
          return payBtns;
        }

        // 待发货
        case 11:
          // 周期购
          if (orderType === 1) {
            return [
              {
                name: "配送计划",
                isLightHeight: false
              },
              {
                name: "提醒发货",
                isLightHeight: true
              }
            ];
          }
          // 自提订单
          if (item.deliveryMode === 0) {
            if (allowBuyAgain) {
              return [
                {
                  name: "再次购买",
                  isLightHeight: true
                }
              ];
            }
            return [];
          }
          // 普通快递模式 (非退款中)
          if (
            item.toBeDeliveredDisposeTypeValue !== "1" &&
            item.toBeDeliveredDisposeTypeValue !== 1
          ) {
            return [
              {
                name: "查看物流",
                isLightHeight: false
              },
              {
                name: "提醒发货",
                isLightHeight: true
              }
            ];
          }
          return [];

        // 待收货
        case 12: {
          // 周期购
          if (orderType === 1) {
            return [
              {
                name: "配送计划",
                isLightHeight: false
              }
            ];
          }
          // 普通快递
          const isRemind =
            i.shipmentTypeValue === "0" || i.shipmentTypeValue === 0;
          if (isRemind) {
            return [
              {
                name: "查看物流",
                isLightHeight: false
              },
              {
                name: "提醒发货",
                isLightHeight: true
              }
            ];
          } else {
            const btns = [
              {
                name: "查看物流",
                isLightHeight: false
              }
            ];
            // 团购订单不展示确认收货
            if (item.kind !== 7) {
              btns.push({
                name: "确认收货",
                isLightHeight: true
              });
            }
            return btns;
          }
        }

        // 已完成
        case 13:
        case 14: {
          // 周期购
          if (orderType === 1) {
            return [
              {
                name: "配送计划",
                isLightHeight: false
              }
            ];
          }
          // 虚拟卡
          if (orderType === 2) {
            return [
              {
                name: "前往使用",
                isLightHeight: true
              }
            ];
          }
          // 普通商品
          const compBtns = [
            {
              name: "查看物流",
              isLightHeight: false
            }
          ];
          if (allowBuyAgain) {
            compBtns.push({
              name: "再次购买",
              isLightHeight: true
            });
          }
          return compBtns;
        }
      }
      return [];
    }
  },
  filters: {
    // 订单包裹的售后状态
    refunDet(status) {
      switch (status) {
        case 1:
          return "订单受理中";
        case 2:
          return "订单受理中";
        case 3:
          return "订单受理中";
        case 4:
          return "订单受理中";
        case 5:
          return "订单受理中";
      }
    }
  },
  methods: {
    isCloseStatus(status) {
      return status < 0 && status !== -5 && status !== -9;
    },
    clickBtn(name) {
      this.$emit(
        "clickBtn",
        name,
        this.item.orderSn,
        this.i.subOrderSn,
        this.packageIndex,
        this.item.orderType,
        this.i.spuId,
        this.item
      );
    }
  }
};
</script>

<style lang="less" scoped>
.bottom_brn {
  padding-bottom: 9px;
  margin: 20px 12px 0 12px;
  display: flex;
  align-items: center;
  .totle_price {
    margin-top: 18px;
  }
  .free_price {
    margin-top: 2px;
  }
  .right_btn {
    display: flex;
    margin-left: auto;
    .cancel_btn {
      width: 84px;
      border-radius: 2px;
      border: 1px solid #000;
    }
    .btn_mr {
      margin-left: 8px;
    }
    .pay_btn {
      width: 84px;
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border-radius: 2px;
      border: 0;
    }
  }
  .refund_det {
    padding: 0;
  }
}
</style>
